<script setup lang="ts">
// import { ToastType } from '~/lib/models/ui/toast'
import { useDialog } from 'primevue/usedialog'
import { profileMenuSection, getAsideTitle } from '~/utils/menuSectionsUtils'
import { imService } from '~/lib/services/im/im.service'

const layoutCustomProps = useAttrs()
const { t } = useLocale()
const authStore = useAuthStore()

const nuxtApp = useNuxtApp()
const isMobile = useIsMobile()
const router = useRoute()
const route = useRoute()
const title = getAsideTitle(router.path)
const { trackLogout } = useGTM()
const { navigateToHome, signInAndSecurityRoute, mySavedAddressesRoute } = useMcdRoutes()
const dialog = useDialog()

const loading = ref<boolean>(true)
// const isDeleteAccountOpen = ref(false)

// const { $toast } = useNuxtApp()

const mustDisplayLogoutDeleteAccount = computed(() => {
  return route.name === 'my-account-sectionSlug' && route.path === signInAndSecurityRoute()
})

const logoutButton = {
  id: 'logout-btn',
  title: t('profile.sections.logout'),
  body: '',
  icon: '/images/icons/profileSections/logout.svg',
  blocked: false,
}

const logout = async () => {
  try {
    await authStore.removeToken()
    trackLogout({ type: 'single' })
    navigateToHome()
  } catch (err) {}
}

const deleteUserAccount = async () => {
  const result = await showDialogAlert({
    dialog,
    data: {
      title: t('profile.subSections.deleteAccount.alert.title'),
      body: t('profile.subSections.deleteAccount.alert.body'),
      btnPrimary: t('profile.subSections.deleteAccount.alert.btnPrimary'),
      btnSecondary: t('profile.subSections.deleteAccount.alert.btnSecondary'),
    },
    customCssClass: 'danger-alert',
  })
  if (result) {
    if (!authStore.token) throw new Error('Invalid access token')
    const success = await imService.deleteUserAccount(authStore.token)
    if (success) {
      await authStore.removeToken()
      navigateToHome()
    }
  }
  // if (success) {
  //   $toast.show({
  //     content: t('profile.subSections.deleteAccount.toast.success'),
  //     type: ToastType.SUCCESS,
  //   })
  // } else {
  //   $toast.show({
  //     content: t('profile.subSections.deleteAccount.toast.error'),
  //     type: ToastType.ERROR,
  //   })
  // }
}

// const showDeleteDialog = () => {
//   isDeleteAccountOpen.value = true
// }

// const closeDeleteDialog = () => {
//   isDeleteAccountOpen.value = false
// }

const hiddenHeadersList = [signInAndSecurityRoute(), mySavedAddressesRoute()]

const displayHeader = computed(() => !hiddenHeadersList.includes(router.path))

nuxtApp.hook('page:start', () => {
  if (process.client) {
    loading.value = true
  }
})

nuxtApp.hook('page:finish', () => {
  loading.value = false
})
</script>

<template>
  <ClientOnly>
    <template v-if="loading">
      <Loader full />
    </template>
    <template v-else-if="isMobile">
      <div class="flex h-svh flex-col justify-between">
        <ProfileMenuMobile
          v-if="!layoutCustomProps.havesection"
          :profile-sections="profileMenuSection()"
        />
        <div v-else>
          <slot></slot>
        </div>
        <footer v-if="mustDisplayLogoutDeleteAccount" class="mx-4 my-8 flex flex-col gap-4">
          <CollapsableWithIcon :collapse="logoutButton" :is-static="true" @click="logout" />
          <button
            class="flex cursor-pointer items-center gap-2 text-xs leading-4 tracking-[-0.15px] text-mcd-secondaryDarkGrey"
            @click="deleteUserAccount"
          >
            {{ t('profile.subSections.deleteAccount.title') }}
          </button>
        </footer>
      </div>
    </template>

    <template v-else>
      <main class="flex w-full justify-center py-12 md:min-h-[75svh]">
        <div class="mx-12 flex w-9/12 items-stretch gap-20">
          <section class="flex w-96 flex-col gap-5">
            <h1 class="text-4xl font-bold">{{ t('profile.title') }}</h1>
            <ClientOnly>
              <UserQRCard />
              <ProfileMenu :profile-sections="profileMenuSection()" />
            </ClientOnly>
          </section>

          <aside class="flex flex-grow flex-col gap-5">
            <header>
              <h1 v-if="displayHeader" class="text-4xl font-bold">{{ title }}</h1>
            </header>
            <main class="flex h-full flex-col justify-between">
              <div>
                <slot></slot>
              </div>
              <footer v-if="mustDisplayLogoutDeleteAccount" class="my-16">
                <CollapsableWithIcon :collapse="logoutButton" :is-static="true" @click="logout" />
                <button
                  class="ml-[5px] flex cursor-pointer items-center gap-2 text-sm leading-4 tracking-[-0.15px] text-mcd-secondaryBlue"
                  @click="deleteUserAccount"
                >
                  {{ t('profile.subSections.deleteAccount.title') }}
                  <img class="h-auto w-4" src="/images/icons/trash_blue.svg" alt="delete" />
                </button>
              </footer>
            </main>
          </aside>
        </div>
      </main>
    </template>

    <template #fallback><Loader full /></template>
  </ClientOnly>
</template>

<style>
.danger-alert .btn-primary {
  @apply !bg-mcd-red text-white;
}
</style>
